<template>
	<div class="storekeeper">
		<audio ref="audioPlayer1" src="../../static/success.mp3"></audio>
		<audio ref="audioPlayer2" src="../../static/error.mp3"></audio>
		<div class="inputdiv">
			<el-form :model="form" label-width="100px" class="demo-ruleForm" @submit.native.prevent="aa">
				<el-form-item label="商品条形码">
					<!-- <el-input ref="myInput" v-model="code" @keyup.native.enter="handleScan" placeholder="请使用扫码枪或手动输入后按回车键"></el-input> -->
					<el-input ref="myInput" v-model="code" @blur="handleScan" @keyup.native.enter="handleScan"
						placeholder="请使用扫码枪或手动输入后按回车键"></el-input>
				</el-form-item>
				<el-form-item label="数量合计" v-if="list.length>0">
					{{mysun}}
				</el-form-item>
			</el-form>
		</div>
		<div class="table">
			<el-table :data="list" style="width: 100%" border>
				<el-table-column prop="barcode" label="条码" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="brand" label="品牌" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="style_number" label="款号" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="size" label="尺码" align="center" header-align="center">
				</el-table-column>
				<el-table-column prop="stock" label="数量" align="center" header-align="center">
				</el-table-column>
				<el-table-column label="操作" align="center" header-align="center">
					<template slot-scope="scope">
						<div class="pm">
							<span @click="onpm('p',scope.row)"><i class="el-icon-plus"></i>增加</span>
							<span @click="onpm('m',scope.row)"><i class="el-icon-minus"></i>减少</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="inputdiv">
			<el-form :model="form" label-width="100px" class="demo-ruleForm">
				<el-form-item label="备注">
					<el-input type="textarea" placeholder="" v-model="form.remark" :rows="3" maxlength="200" show-word-limit></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="btns">
			<el-button type="primary" size="small" icon="el-icon-plus" @click="onsub(1)">盘点单提交</el-button>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'scancodebuy',
		data() {
			return {
				form: {
					remark: ""
				},
				code: "",
				list: [],
				mysun: 0
			}
		},

		mounted() {
			this.$nextTick(() => {
				this.$refs.myInput.focus();
			});
		},

		methods: {
			handleScan(e) {
				var val = JSON.parse(JSON.stringify(this.code));
				if (val) {
					this.mysun = 0;
					this.code = "";
					if (this.list && this.list.length > 0) {
						var tjs = false;
						this.list.forEach((v, k) => {
							if (v.barcode == val) {
								v.stock++;
								tjs = true;
								this.playSound();
							}
							this.mysun = this.mysun + v.stock;
						})
						if (!tjs) {
							this.getbarcode(val);
						}
					} else {
						this.getbarcode(val);
					}

					this.$refs.myInput.focus();
				}
			},

			getbarcode(val) {
				var obj = {};
				obj.barcode = val;
				this.$axios.post('api/user/get_product_by_barcode', obj).then(res => {
					if (res.data.code == 0) {
						if (res.data.data && Object.keys(res.data.data) != 0) {
							res.data.data.stock = 1;
							this.mysun += 1;
							this.list.push(res.data.data);
							this.playSound();
						} else {
							this.$message.warning('没有查询到该条码信息');
							this.playError();
						}
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onpm(s, obj) {
				if (s == 'p') {
					obj.stock++;
					this.mysun++;
				}

				if (s == 'm') {
					if (obj.stock != 0) {
						obj.stock--;
						this.mysun--;
					}

				}
			},

			onsub(s) {
				if (this.list.length == 0) {
					this.$message.warning('清先添加数据');
					return;
				}
				var obj = {};
				var arr = [];
				this.list.forEach((v, k) => {
					var obj1 = {};
					obj1.product_id = v.product_id;
					obj1.size_id = v.size_id;
					obj1.stock = v.stock;
					arr.push(obj1);
				})
				obj.remark = this.form.remark;
				obj.update = JSON.stringify(arr);
				this.$axios.post('api/user/user_stock_taking_add', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功');
						this.$emit('subscan');
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			playSound() {
				this.$refs.audioPlayer1.currentTime = 0;
				this.$refs.audioPlayer1.play();
			},
			
			playError() {
				this.$refs.audioPlayer2.currentTime = 0;
				this.$refs.audioPlayer2.play();
			},

			aa() {

			}
		}
	}
</script>

<style scoped lang="less">
	.el-input {
		width: 600px;
	}
	
	.el-textarea {
		width: 600px;
	}

	.table {
		margin: 25px 0;
	}

	.btns {
		/deep/ i {
			font-size: 14px;
		}
	}

	.pm {
		span {
			margin: 0 5px;
			cursor: pointer;
			color: #ff4714;
		}
	}
</style>



// WEBPACK FOOTER //
// src/common/scancodebuy.vue